import type { EnvironmentType } from './environment.type';
import type { Provider } from '@angular/core';
import { Environment } from './environment.injector';

export * from './environment.type';
export * from './environment.injector';

export function withEnvironment(environment: EnvironmentType): Provider {
  return {
    provide: Environment,
    useValue: environment,
  };
}
